.participantContainer {
    background-color: var(--mantine-color-dark-6);
    border-radius: var(--mantine-radius-md);
    padding: var(--mantine-spacing-xs);
    padding-left: var(--mantine-spacing-md);
    padding-right: var(--mantine-spacing-md);
}

.primaryBackground {
    background-color: rgba(106, 27, 185, 0.3); /* --mantine-color-asurion-8  manually converted to 30% opacity */
}

.disabledBackground {
    background-color: var(--mantine-color-dark-8);
}
